import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider } from 'primereact/api';
import AppLoadingIndicator from './components/common/appLoadingIndicator';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <Suspense fallback={<AppLoadingIndicator />}>
    <PrimeReactProvider value={{ hideOverlaysOnDocumentScrolling: false }}>
      <App />
    </PrimeReactProvider>
  </Suspense>
  // </React.StrictMode>
);

reportWebVitals();
